
import {Component} from 'san';
import styles from './style/index.module.less';
import TtsBtn from '../ttsBtn';
import {getYearDate} from '../../utils/index';
import Follow from '../follow';

export default class Header extends Component {
    static template = require('./index.html');
    static components = {
        'ui-tts-btn': TtsBtn,
        'ui-follow': Follow,
    };
    static computed = {
        itemData() {
            return this.data.get('data.itemData');
        },
        info() {
            return this.data.get('data.itemData.info');
        },
        infoB() {
            return this.data.get('data.itemData.infoBaiJiaHao');
        },
        ipAddress() {
            const infoBjh = this.data.get('data.itemData.infoBaiJiaHao') || {};
            const iptopoi = infoBjh.iptopoi || {};
            if (iptopoi.CountryName && iptopoi.CountryName === '中国' && iptopoi.Province) {
                return iptopoi.Province || '';
            } else {
                return iptopoi.CountryName || '';
            }
        },
        updatetime() {
            return getYearDate(this.data.get('displaytime'));
        },
    };

    initData() {
        return {
            styles,
        };
    }

    /* eslint-disable import/newline-after-import */
};
